import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import "./quasar";
import Clipboard from "v-clipboard";
import LoadingDialog from "@/components/LoadingDialogComponent";

import { getApp } from "firebase/app";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";

Vue.use(Clipboard);

Vue.config.productionTip = false;

Vue.component("loading-dialog", LoadingDialog);

// UNCOMMENT FOR DEV PURPOSES
if (document.URL.includes("localhost")) {
  const functions = getFunctions(getApp());
  connectFunctionsEmulator(functions, "localhost", 5001);
}

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
